module.exports = __webpack_public_path__ + "img/icon-setting-active.1f0afe1.svg";